/**
 * Authentication hook
 * 
 * @author Claude
 */
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Hook to access the authentication context
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

export default useAuth;